import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import startCase from 'lodash/startCase';
import { FontIcon } from 'office-ui-fabric-react/lib/Icon';
import { TooltipHost } from 'office-ui-fabric-react';
import DetailsList from '../DetailsList';
import styles from './ProductAgreementsList.style';
import appStyles from '../../App.style';
import { contractStatus } from '../../utils';

const columns = [
  {
    key: 'status',
    name: 'Status',
    headerClassName: styles.iconColumnHeader,
    iconClassName: styles.headerIcon,
    ariaLabel: 'Status',
    iconName: 'TextDocument',
    isIconOnly: true,
    fieldName: 'status',
    minWidth: 8,
    maxWidth: 8,
    columnActionsMode: 0,
    onRender: (contract, index) => {
      const status = contractStatus(
        contract.effectiveDate,
        contract.terminationDate,
        contract.approvalStatus,
      );

      return (
        <>
          <TooltipHost
            content={startCase(status)}
            calloutProps={{
              gapSpace: 0,
              target: `#${`statusIcon${index}`}`,
            }}
          >
            <div className={clsx(styles.iconColumn, appStyles[`${status}Color`])}>
              <FontIcon iconName="LocationDot" ariaLabel="TextDocument" id={`statusIcon${index}`} />
            </div>
          </TooltipHost>
        </>
      );
    },
  },
  {
    key: 'name',
    name: 'Contract Name',
    fieldName: 'name',
    minWidth: 320,
    maxWidth: 320,
    columnActionsMode: 0,
  },
  {
    key: 'contractId',
    name: 'Contract ID',
    fieldName: 'contractId',
    minWidth: 185,
    maxWidth: 185,
    columnActionsMode: 0,
    onRender: contract => `#${contract.contractId}`,
  },
  {
    key: 'agreement',
    name: 'Royalty Fee',
    fieldName: 'agreement',
    minWidth: 150,
    maxWidth: 150,
    columnActionsMode: 0,
  },
];

const ProductAgreementsList = ({ items, className: classNameProp, ...other }) => {
  const className = clsx(classNameProp);

  return <DetailsList items={items} columns={columns} className={className} {...other} />;
};

ProductAgreementsList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      address: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      contractId: PropTypes.string.isRequired,
      agreement: PropTypes.string.isRequired,
    }),
  ),
  className: PropTypes.string,
};

ProductAgreementsList.defaultProps = {
  items: [],
  className: '',
};

export default ProductAgreementsList;
